import cx from 'classnames'
import { motion } from 'motion/react'
import { FC, useMemo } from 'react'
import { BlockTitleProps } from 'src/components/BlockTitle'
import { Icons } from 'src/components/Icon'
import { LinkProps } from 'src/components/Link'
import { motionGroup, slideReveal } from 'src/hooks/useAppear'

import * as SC from './styled'

type MiniPushLink = LinkProps & { color?: string }
export type MiniPushProps = {
  color?: string
  index: number
  isMobile?: boolean
  link: MiniPushLink
}
export type MiniPushesProps = {
  className?: string
  blockTitleProps?: BlockTitleProps
  links?: MiniPushLink[]
  color?: string
}

const MiniPush: FC<MiniPushProps> = ({ color, index, isMobile, link }) => {
  const { variants } = useMiniPushesMotion()

  return (
    <motion.li variants={variants.link(index, isMobile)}>
      <SC._Link {...link} $color={link.color || color}>
        <SC.Label>{link.label || link.text}</SC.Label>
        <SC.Arrow icon={Icons.bigArrowRight} />
      </SC._Link>
    </motion.li>
  )
}

const MiniPushes: FC<MiniPushesProps> = ({
  className,
  blockTitleProps,
  links = [],
  color,
}) => {
  const { motions } = useMiniPushesMotion()

  return (
    <SC.Container className={cx('MiniPushes', className)}>
      {blockTitleProps && <SC._BlockTitle {...blockTitleProps} color={color} />}
      {links.length > 0 && (
        <>
          <SC.Links {...motions.links} $mobile>
            {links.map((link, index) => (
              <MiniPush
                isMobile
                key={`link-${index}`}
                index={index}
                link={link}
                color={color}
              />
            ))}
          </SC.Links>
          <SC.Links {...motions.links}>
            {links.map((link, index) => (
              <MiniPush
                key={`link-${index}`}
                index={index}
                link={link}
                color={color}
              />
            ))}
          </SC.Links>
        </>
      )}
    </SC.Container>
  )
}

const useMiniPushesMotion = () => {
  const motions = useMemo(
    () => ({
      links: motionGroup({}).motionProps,
    }),
    []
  )

  const variants = useMemo(
    () => ({
      link: (index: number, isMobile?: boolean) =>
        slideReveal({ delay: isMobile ? index * 0.04 : 0.12 * (index % 3) }),
    }),
    []
  )

  return { motions, variants }
}

export default MiniPushes
